import React from 'react';
import Icon from '../../../components/AppIcon';

const SettingsSidebar = ({ tabs, activeTab, onTabChange }) => {
  return (
    <div className="bg-surface border border-border rounded-lg overflow-hidden">
      <nav className="space-y-1 p-2">
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`
              w-full flex items-center px-3 py-2.5 text-sm font-medium rounded-md transition-colors duration-200
              ${activeTab === tab.id
                ? 'bg-primary text-white shadow-sm'
                : 'text-text-secondary hover:text-text-primary hover:bg-surface-hover'
              }
            `}
          >
            <Icon 
              name={tab.icon} 
              size={18} 
              className={`mr-3 flex-shrink-0 ${
                activeTab === tab.id ? 'text-white' : 'text-text-muted'
              }`} 
            />
            <span className="text-left">{tab.label}</span>
            
            {/* Optional badge/indicator */}
            {tab.badge && (
              <span className={`
                ml-auto inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium
                ${activeTab === tab.id
                  ? 'bg-white/20 text-white'
                  : 'bg-primary-100 text-primary-700'
                }
              `}>
                {tab.badge}
              </span>
            )}

            {/* Coming soon indicator */}
            {tab.comingSoon && (
              <span className="ml-auto inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium bg-yellow-100 text-yellow-700">
                Soon
              </span>
            )}
          </button>
        ))}
      </nav>
    </div>
  );
};

export default SettingsSidebar; 